import LargeContainer from '@/components/front-office/containers/LargeContainer';
import Button from '@/components/Button';
import InstructionsModal from '@/components/front-office/InstructionsModal';
import { useState } from 'react';
import { useSettings } from '@/contexts/SettingsContext';

const Home = () => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const { isMenuPageEnabled, isHaguimModeEnabled, haguimName } = useSettings();

	// Déterminer le texte à afficher en fonction du mode haguim
	const celebrationText = isHaguimModeEnabled && haguimName ? haguimName : 'shabbat';

	return (
		<LargeContainer>
			{/* <PushNotificationsButton /> */}

			<div className="mb-2 text-sm md:mb-6 md:text-xl mt-2">
				<p>Bienvenue sur le site de commande Rivka Traiteur</p>
				<p>Commandez votre {celebrationText} partout en France</p>
				<Button
					text={'Lire les instructions de commande'}
					type={'Button'}
					action={'button'}
					handleClick={() => setIsModalOpen(true)}
					disabled={true}
					withTopMargin={false}
				/>
			</div>

			<div>
				<p className="text-xl mb-4 md:mb-8 lg:text-3xl color:red">Vous souhaitez:</p>

				<div className={`grid grid-cols-1 gap-4 ${isMenuPageEnabled ? 'md:grid-cols-1' : 'md:grid-cols-1 md:w-1/2 md:mx-auto'}`}>
					{/* {isMenuPageEnabled && (
						<Button
							text={'Voir le menu'}
							type={'Button'}
							action={'button'}
							handleClick={() => (window.location.href = '/menu-page')}
							disabled={true}
							withTopMargin={false}
						/>
					)} */}

					<Button
						text={'Commander'}
						type={'Button'}
						action={'button'}
						handleClick={() => (window.location.href = '/commande/adresse')}
						disabled={true}
						withTopMargin={false}
					/>
				</div>
			</div>

			<InstructionsModal
				isOpen={isModalOpen}
				onClose={() => setIsModalOpen(false)}
			/>
		</LargeContainer>
	);
};

export default Home;
